__turbopack_context__.v({
  "className": "textfontloader_84a2d8fd-module__mbEAca__className",
  "variable": "textfontloader_84a2d8fd-module__mbEAca__variable",
});
